module.exports = __webpack_public_path__ + "img/partnership_process_01.ca10597b.png";